'use client';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { cn } from "../../../lib/utils";
import { memo, useEffect } from 'react';
import { injectPopoverStyles } from "./styles";
import useCountDown from "./useCountdown";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
injectPopoverStyles();
var isBrowser = typeof window !== 'undefined';
var defaultDisplayConfig = {
  day: true,
  hour: true,
  minute: true,
  second: true
};
var formatNum = function formatNum(num) {
  if (num < 10) {
    return "0".concat(num);
  }
  return "".concat(num);
};
export var timeUnitMap = {
  day: 'D',
  hour: 'H',
  minute: 'M',
  second: 'S'
};
export var fulltimeUnitMap = {
  day: 'DAY',
  hour: 'HOUR',
  minute: 'MINUTE',
  second: 'SECOND'
};
var CountdownItem = function CountdownItem(_ref) {
  var num = _ref.num,
    mode = _ref.mode,
    unit = _ref.unit;
  var isEasyMode = mode === 'easy';
  var numStr = formatNum(num);
  if (isEasyMode) {
    return /*#__PURE__*/_jsxs("div", {
      className: "item",
      children: [/*#__PURE__*/_jsx("div", {
        className: cn('num', {
          three: (numStr === null || numStr === void 0 ? void 0 : numStr.length) >= 3
        }),
        children: /*#__PURE__*/_jsx("span", {
          className: "inner",
          children: numStr
        })
      }), /*#__PURE__*/_jsx("span", {
        className: "desc",
        children: timeUnitMap[unit]
      })]
    });
  }
  var nums = (numStr || '').split('');
  return /*#__PURE__*/_jsxs("div", {
    className: cn('item', 'full'),
    children: [/*#__PURE__*/_jsx("div", {
      className: "group",
      children: nums.map(function (num, idx) {
        return /*#__PURE__*/_jsx("span", {
          className: "num",
          children: /*#__PURE__*/_jsx("span", {
            className: "inner",
            children: num
          })
        }, idx);
      })
    }), /*#__PURE__*/_jsx("span", {
      className: "desc",
      children: fulltimeUnitMap[unit]
    })]
  });
};
var Countdown = function Countdown(_ref2) {
  var targetTimestamp = _ref2.targetTimestamp,
    className = _ref2.className,
    strong = _ref2.strong,
    size = _ref2.size,
    onEnd = _ref2.onEnd,
    onChange = _ref2.onChange,
    _ref2$display = _ref2.display,
    display = _ref2$display === void 0 ? defaultDisplayConfig : _ref2$display,
    _ref2$mode = _ref2.mode,
    mode = _ref2$mode === void 0 ? 'easy' : _ref2$mode;
  var _useCountDown = useCountDown({
      targetDate: targetTimestamp,
      onEnd: onEnd
    }),
    _useCountDown2 = _slicedToArray(_useCountDown, 2),
    _useCountDown2$ = _useCountDown2[1],
    days = _useCountDown2$.days,
    hours = _useCountDown2$.hours,
    minutes = _useCountDown2$.minutes,
    seconds = _useCountDown2$.seconds;
  useEffect(function () {
    if (onChange) {
      onChange(targetTimestamp - Date.now(), Date.now());
    }
  }, [seconds]);
  return isBrowser ? /*#__PURE__*/_jsxs("div", {
    className: cn('moly-countdown', "".concat(size || 'middle'), className, {
      strong: strong
    }),
    children: [display !== null && display !== void 0 && display.day ? /*#__PURE__*/_jsx(CountdownItem, {
      num: days,
      mode: mode,
      unit: "day"
    }) : null, display !== null && display !== void 0 && display.hour ? /*#__PURE__*/_jsx(CountdownItem, {
      num: hours,
      mode: mode,
      unit: "hour"
    }) : null, display !== null && display !== void 0 && display.minute ? /*#__PURE__*/_jsx(CountdownItem, {
      num: minutes,
      mode: mode,
      unit: "minute"
    }) : null, display !== null && display !== void 0 && display.second ? /*#__PURE__*/_jsx(CountdownItem, {
      num: seconds,
      mode: mode,
      unit: "second"
    }) : null]
  }) : /*#__PURE__*/_jsx("div", {
    className: cn('moly-countdown', className)
  });
};
export default /*#__PURE__*/memo(Countdown);